export interface TaxZoneClass {
    AccountTaxZoneId: number
    AccountTaxZone: string
    CreatedOn: Date | undefined
    CreatedByEmployeeId: number
    ModifiedOn: Date | undefined
    ModifiedByEmployeeId: number
    IsDisabled: boolean
    MasterTaxZoneId: number
    AccountTaxZoneGuidId: string
    IsDeleted: boolean
    isSelected:number
}

export const taxZoneInitialsForAdd = {
    AccountTaxZone: "",
    IsDisabled: false
}

export const taxZoneInitialsForUpdate = {
    AccountTaxZone: "",
    AccountTaxZoneId: "",
    IsDisabled: false
}